import { _ as c } from "./extends-093996c9.js";
import e from "react";

var t = function t(_t) {
  var r = _t.dark,
      o = void 0 === r ? "#000000" : r,
      l = _t.light,
      a = void 0 === l ? "#ffffff" : l,
      s = _t.schema,
      n = {
    isotypebackground: o,
    isotypeletter: o,
    letters: o
  };
  return "light" === (void 0 === s ? "common" : s) && (n.isotypebackground = a, n.isotypeletter = a, n.letters = a), e.createElement("svg", c({
    x: "0px",
    y: "0px",
    viewBox: "0 0 390.3 160.4"
  }, _t), e.createElement("g", {
    fill: n.letters
  }, e.createElement("polygon", {
    points: "169.6,1.8 169.6,158.9 230.3,158.9 230.3,137.4 229.1,137.4 195.7,137.4 195.7,1.8 "
  }), e.createElement("path", {
    d: "M71.6,46.4c0,16.7,2,33.1-7,42.7c-7.6,8.1-15.4,11.3-38.9,10.1v59.8H0V1.8h37.1c13.7,0,25.9,4.3,31.4,16.3 C71.7,25.3,71.6,36.1,71.6,46.4 M45.8,46c0-6.7,0.3-12.1-0.3-15.3c-1.3-6.3-5.5-6.6-11.7-6.6h-8.1v53.2h10.5c4,0.1,8.4-1,9.1-5.2 C46.2,67.5,45.8,60.2,45.8,46"
  }), e.createElement("path", {
    d: "M153.7,2H128l0.4,128.1c0,0,0,7.3-10.6,7.6c-11,0.4-10.1-10.3-10.1-8.9V2H81.4l0.4,126c0,0-2.2,31.7,34.5,32.5 c5.9,0,35.5,0.1,37.5-29C154.2,122.1,153.7,1.9,153.7,2"
  }), e.createElement("path", {
    d: "M390.3,127c0,9.3-2.2,17.6-9.2,24c-7.1,6.4-17.1,8.7-26.9,8.7c-10.6,0-19.1-2.1-26.1-8c-7-5.9-10.1-14.3-10.1-24.2 l-0.1-95.5c0-9.3,3.2-18.3,10.4-24.4c7-5.6,16.2-7.8,26.6-7.8c9.5,0,18.7,2.6,26,8.8s9.3,15,9.3,22.5L390.3,127z M364.4,126.8V32.3 c0-2.3-0.4-9.7-10.2-9.7c-9.3,0-10.3,6.3-10.3,9.7v94.4c0,3.3,0.3,10.4,10.3,10.3C364.2,137,364.4,130.2,364.4,126.8"
  }), e.createElement("path", {
    d: "M306.9,120.7c0,15.6-1.5,21.6-7.3,28.7c-5.2,6.4-15.7,10.6-28.2,10.6c-9.7,0-19.3-1.8-26.4-7.6 c-7.8-6.1-10.5-14.6-10.5-24.4v-25.5h25.3V120c0.1,5.9-0.7,10.3,1.3,13.2s4.6,4.4,10.1,4.1c4.7-0.2,8-2.1,9.3-4.8 c1.2-2.5,0.6-5.7,0.6-11c0-8.7,0.4-16-11.1-24.4s-18.9-13.2-26.4-22.6c-10.6-13.4-8.3-31.6-8.4-35.5c-0.5-14.6,0.4-20.6,5.9-27.4 c6.2-8,17.3-11.5,29.8-11.5c11.1,0,20.5,3.1,27.1,9.9c6,6.3,7.9,14.5,7.9,24v22.8h-25c0.3-1.8,0-9.8,0-15.5s0.5-9.9-0.5-12.6 c-1.8-4.2-4.6-6.1-10.3-5.9c-2.5-0.1-5,0.7-7,2.2c-2.6,2.1-2.9,6-2.4,14.6c0.2,3.8-0.3,7.5,0.4,10.8c0.9,4.7,3.5,8.8,8.9,13.3 c8.5,7,19,13.1,26.2,21.7C306.5,97.7,306.9,107.4,306.9,120.7"
  })));
};

export { t as Pulso };